import {
  RadialBarChart,
  RadialBar,
  ResponsiveContainer,
} from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { COLORS } from "./theme";
import LearnLink from "./LearnLink";

export default function HealthScoreCard({ health }) {
  const insufficient = health.overall_score === null || health.overall_score === undefined;
  const score = insufficient ? 0 : Number(health.overall_score || 0);
  const data = [{ name: "score", value: score, fill: COLORS.primary }];
  return (
    <Card
      className="lg:col-span-4 bg-white border-[#E5E0D8] shadow-none overflow-hidden"
      data-testid="health-score-card"
    >
      <CardHeader className="pb-2">
        <CardDescription className="text-xs uppercase tracking-[0.18em] text-[#5C665D]">
          CFO Grade
        </CardDescription>
        {insufficient ? (
          <CardTitle className="font-serif-display text-2xl text-[#1F382E]">
            Not enough data <span className="text-sm text-[#5C665D] font-sans font-normal">to score</span>
          </CardTitle>
        ) : (
          <CardTitle className="font-serif-display text-3xl text-[#1F382E] flex items-baseline gap-3 flex-wrap">
            <span
              className="font-serif-display text-[3.25rem] sm:text-[3.75rem] text-[#C26D5C] tabular-nums leading-none tracking-tight"
              data-testid="cfo-letter-grade"
            >
              {health.letter_grade || "—"}
            </span>
            <span className="text-[#5C665D] text-sm font-sans font-normal tabular-nums">
              {score} / 100
            </span>
          </CardTitle>
        )}
      </CardHeader>
      <CardContent className="pt-2">
        {insufficient ? (
          <div className="h-44 flex flex-col items-center justify-center text-center px-4 text-[#5C665D]">
            <p className="text-sm leading-relaxed">
              {health.insufficient_reason ||
                "There isn't enough information to compute a meaningful score for this period."}
            </p>
          </div>
        ) : (
          <div className="h-44">
            <ResponsiveContainer>
              <RadialBarChart
                cx="50%"
                cy="50%"
                innerRadius="65%"
                outerRadius="100%"
                barSize={16}
                data={data}
                startAngle={90}
                endAngle={-270}
              >
                <RadialBar
                  dataKey="value"
                  cornerRadius={20}
                  background={{ fill: "#E5E0D8" }}
                  fill={COLORS.primary}
                  isAnimationActive
                />
              </RadialBarChart>
            </ResponsiveContainer>
          </div>
        )}
        <p className="text-sm text-[#5C665D] leading-relaxed">
          {insufficient
            ? "Add a P&L period (revenue, costs, OCF) to get a meaningful health score."
            : "A weighted blend of profitability, liquidity, solvency and efficiency scores."}
        </p>
        {!insufficient && (
          <div className="mt-3">
            <LearnLink
              slug="letter-grade"
              label="How is this grade calculated?"
              source="health_score_card"
              variant="cta"
            />
          </div>
        )}
      </CardContent>
    </Card>
  );
}
